import { createActions } from 'redux-actions';
import { CancerClaim } from '@models/CancerClaim';

export type State = {
  cancerClaim: CancerClaim | null | undefined;
};
export type StateUpdatePayload = Partial<State>;

export const {
  cancerClaimFetch,

  stateUpdate,
} = createActions(
  'CANCER_CLAIM_FETCH',

  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_CLAIM_DETAILS_CANCER_CLAIM_DETAILS',
  },
);
